const forecast_categoryList = [
    { key: 0, name: "Omitted" },
    { key: 1, name: "Best Case" },
    { key: 2, name: "Upside" },
    { key: 3, name: "Commit" },
];

export default forecast_categoryList;